import React, { useEffect, useState } from "react";
import { Loader2, Plus, Save, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export default function ClientMotifsPanel() {
  const [d, setD] = useState(null);
  const [add, setAdd] = useState("");
  useEffect(() => { api.get("/sav/client-motifs").then((r) => setD(r.data)); }, []);
  if (!d) return <Loader2 className="w-5 h-5 animate-spin" />;
  const set = (items) => setD({ ...d, items });
  const save = async () => {
    try { setD((await api.put("/sav/client-motifs", { items: d.items })).data); toast.success("Motifs enregistrés"); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };
  return (
    <div className="card-flat p-5 max-w-2xl space-y-3" data-testid="client-motifs-panel">
      <h3 className="font-heading text-base font-medium">Motifs des demandes client</h3>
      <p className="text-xs text-norea-textMuted">Liste proposée dans « Motif de la demande client ». Le montant du bonus écologique s'affiche quand le motif est « Bonus écologique ».</p>
      {d.provisoire && <p className="text-[11px] text-amber-700" data-testid="client-motifs-provisoire">Liste provisoire — à valider par Norea.</p>}
      <div className="space-y-1.5">
        {d.items.map((m, i) => (
          <div key={i} className="flex items-center gap-2">
            <input className="input-field flex-1" value={m} onChange={(e) => set(d.items.map((x, j) => (j === i ? e.target.value : x)))} data-testid={`client-motif-${i}`} />
            <button onClick={() => set(d.items.filter((_, j) => j !== i))} className="p-1.5 text-norea-textMuted hover:text-red-700" data-testid={`client-motif-delete-${i}`}><X className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <input className="input-field flex-1" placeholder="Nouveau motif" value={add} onChange={(e) => setAdd(e.target.value)} data-testid="client-motif-new" />
        <button onClick={() => { if (add.trim()) { set([...d.items, add.trim()]); setAdd(""); } }} className="btn-secondary text-xs" data-testid="client-motif-add"><Plus className="w-3.5 h-3.5" />Ajouter</button>
        <button onClick={save} className="btn-primary text-xs" data-testid="client-motifs-save"><Save className="w-3.5 h-3.5" />Enregistrer</button>
      </div>
    </div>
  );
}
